import { AuthStorage } from "utils/auth-storage";
import { React, useEffect } from "react";
import { Button, Popover, Modal, Alert } from "antd";
import { useState } from "react";
import { ProjectServices } from "apis/Services/ProjectService";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";
import { reloadProjects } from "redux/project-reducer";
import {
  AppstoreAddOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";

import ProcoreLogo from "assets/images/Procore_Logo.svg";
import { useDispatch } from "react-redux";

function PostSubmittals({
  projectDetails,
  projectsAccessLevelValue,
  checkedRows,
  setCheckedRows,
  onSuccess,
}) {
  const { company_id, id } = useParams();
  const [isProcore, setIsProcore] = useState();
  const [hasSubmittalName, setHasSubmittalName] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [errorList, setErrorList] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState();
  const [procoreData, setProcoreData] = useState();
  const dispatch = useDispatch();

  const handlePosting = () => {
    if (projectsAccessLevelValue >= 2) {
      const selectedData = [];
      const divisionNames = [];

      const procoreData = [];
      const procoreDivisionNames = [];

      const entryIDs = new Set(
        Object.keys(checkedRows)
          .filter((entryID) => checkedRows[entryID])
          .map(String),
      );

      // Filtering data that matches entryID
      for (const key of Object.keys(projectDetails.content)) {
        const division = projectDetails.content[key];
        const subDivisions = Object.values(division);
        subDivisions.forEach((subDivision) => {
          subDivision.forEach((item) => {
            if (entryIDs.has(String(item.entryID))) {
              if (
                (item.specNumber !== "" && item.entryOrigin !== "Procore") ||
                (item.specRevision !== "" && item.entryOrigin !== "Procore")
              ) {
                setHasSubmittalName(true);
              }
              if (item.entryOrigin !== "Procore") {
                // Adding only koncurent entries to the request
                selectedData.push(item);
                if (!divisionNames.includes(key)) {
                  divisionNames.push(key);
                }
              } else {
                procoreData.push(item);
                if (!procoreDivisionNames.includes(key)) {
                  procoreDivisionNames.push(key);
                }

                // Procore flag to show the warning
                // setIsProcore("Some");
              }
            }
          });
        });
      }

      // if (selectedData.length === 0) {
      //   setIsProcore("All");
      // }

      setData({ selectedData, divisionNames });

      setProcoreData({ procoreData, procoreDivisionNames });

      setIsModalOpen(true);
    }
  };

  function handleOk() {
    postData(data, procoreData);
  }

  function handleIgnore() {
    // if submittal number is filleed or revision is filled then ignore.
    const selectedData = data.selectedData.filter(
      (item) => item.specNumber === "" && item.specRevision === ""
    );

    let divisionNames = data.divisionNames;
    let updatedData = { selectedData, divisionNames };

    if (selectedData.length > 0) {
      postData(updatedData);
    } else {
      handleCancel();
    }
  }

  function handleCancel() {
    setIsModalOpen(false);
    setIsProcore();
    setHasSubmittalName(false);
  }

  function handleCancelErrorModal() {
    setErrorModal(false);
  }

  function postData(data, procoreData) {
    const toastId = toast.loading("Posting submittals in progress");
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let authData = {
      company: company_id,
      project: id,
      code,
      loginEmail: email,
    };
    setIsModalOpen(false);

    // Create an array of promises for both operations
    const promises = [];

    // Add post request if there's data to post
    if (data && data.selectedData && data.selectedData.length > 0) {
      promises.push(
        ProjectServices.procurementLogPostSubmittalToProcore(data, authData)
      );
    }

    // Add update request if there's procoreData to update
    if (
      procoreData &&
      procoreData.procoreData &&
      procoreData.procoreData.length > 0
    ) {
      const data = {
        selectedData: procoreData.procoreData,
        divisionNames: procoreData.procoreDivisionNames,
      };

      promises.push(
        ProjectServices.procurementLogUpdateSubmittalToProcore(data, authData)
      );
    }

    if (promises.length === 0) {
      setIsModalOpen(false);
      toast.error("No selected submittals are available to post.", {
        id: toastId,
      });
      return;
    }

    const processedEntryIDs = [
      ...(data?.selectedData || []).map((item) => item.entryID),
      ...(procoreData?.procoreData || []).map((item) => item.entryID),
    ];

    // Execute all promises
    Promise.allSettled(promises)
      .then((results) => {
        let hasErrors = false;
        let allErrors = [];
        const hasSuccessfulOperation = results.some(
          (result) => result.status === "fulfilled",
        );

        results.forEach((result, index) => {
          if (result.status === "fulfilled") {
            // Check if there are errors in the response
            if (result.value && result.value.length > 0) {
              hasErrors = true;
              allErrors = allErrors.concat(result.value);
            }
          } else {
            // Promise was rejected
            hasErrors = true;
            console.error(`Operation ${index + 1} failed:`, result.reason);

            // NEW: Handle case where reason itself is the array of errors
            if (Array.isArray(result.reason)) {
              allErrors = allErrors.concat(result.reason);
            } else if (Array.isArray(result.reason?.response?.data)) {
              allErrors = allErrors.concat(result.reason.response.data);
            } else if (result.reason?.response?.data?.errors) {
              allErrors = allErrors.concat(
                result.reason.response.data.errors.map((msg) => ({
                  "Spec Section": "",
                  "Submittal Title": "",
                  "Submittal Number": "",
                  "Submittal Revision": "",
                  "Column Name": "",
                  "Column Value": "",
                  Error: msg,
                }))
              );
            } else if (result.reason?.message) {
              allErrors.push({
                "Spec Section": "",
                "Submittal Title": "",
                "Submittal Number": "",
                "Submittal Revision": "",
                "Column Name": "",
                "Column Value": "",
                Error: result.reason.message,
              });
            } else {
              allErrors.push({
                "Spec Section": "",
                "Submittal Title": "",
                "Submittal Number": "",
                "Submittal Revision": "",
                "Column Name": "",
                "Column Value": "",
                Error: String(result.reason),
              });
            }
          }
        });

        if (hasErrors) {
          allErrors.concat(results?.[0]);
          console.log(results, "!!!!");

          if (allErrors.length > 0) {
            setErrorModal(true);
            setErrorList(allErrors);
          }
          toast.success("Submittals processed with some issues!", {
            id: toastId,
          });
        } else {
          toast.success("Submittals posted successfully!", { id: toastId });
        }

        if (hasSuccessfulOperation) {
          onSuccess?.(processedEntryIDs);
        }

        setCheckedRows([]);
        dispatch(reloadProjects());
      })
      .catch((err) => {
        console.error("Unexpected error:", err);
        toast.error("Something went wrong, please try again.", {
          id: toastId,
        });
      })
      .finally(() => {
        setIsModalOpen(false);
        setIsProcore();
        setHasSubmittalName(false);
      });
  }

  return (
    <div>
      <div
        onClick={handlePosting}
        className=" d-flex justify-content-left gap-2 align-items-center"
      >
        <img src={ProcoreLogo} alt="Procore" width={16} />
        Create/Update Submittal
      </div>
      <Modal
        open={isModalOpen}
        width={700}
        onOk={isProcore !== "All" ? handleOk : null}
        onCancel={handleCancel}
        footer={
          hasSubmittalName && isProcore !== "All"
            ? [
                <Button key="cancel" onClick={handleCancel}>
                  Cancel
                </Button>,
                <Button key="ignore" onClick={handleIgnore}>
                  Skip These Items
                </Button>,
                <Button key="overwrite" type="primary" onClick={handleOk}>
                  Overwrite
                </Button>,
              ]
            : isProcore === "All"
            ? [
                <Button key="cancel" onClick={handleCancel}>
                  Cancel
                </Button>,
                <Button key="confirm" type="primary" disabled>
                  Confirm
                </Button>,
              ]
            : [
                <Button key="cancel" onClick={handleCancel}>
                  Cancel
                </Button>,
                <Button key="confirm" type="primary" onClick={handleOk}>
                  Confirm
                </Button>,
              ]
        }
      >
        <div className="">
          <div className="d-flex align-items-center gap-2">
            <h5 className="fw-bold pt-2">
              Selected submittals will be posted to Procore
            </h5>
          </div>
          <div className=" d-flex flex-column">
            <p>
              Submittal numbers and submittal revisions will be generated for
              all posted entries, to match Procore’s submittal requirements.
            </p>

            {isProcore === "Some" ? (
              <Alert
                message="Some of the selected items already exist in Procore, such items will not be posted."
                type="warning"
                showIcon
              />
            ) : isProcore === "All" ? (
              <>
                {/* <Alert
                  message="
                All selected items are already present in Procore."
                  type="error"
                  showIcon
                /> */}
              </>
            ) : (
              <></>
            )}

            {hasSubmittalName && isProcore !== "All" ? (
              <Alert
                message="If some of the selected items have a submittal name and/or submittal revision, they may be overwritten to match Procore’s requirements."
                type="warning"
                className="mt-2"
                showIcon
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      </Modal>

      <Modal
        open={errorModal}
        width={500}
        onCancel={handleCancelErrorModal}
        maskClosable={false}
        footer={[
          <Button key="close" onClick={handleCancelErrorModal}>
            Close
          </Button>,
        ]}
      >
        <div className="d-flex flex-column">
          <h5>Error Message</h5>
          {errorList && (
            <Alert
              style={{ maxHeight: "400px", overflowY: "auto" }}
              description={
                <div>
                  {errorList.map((error, index) => (
                    <div
                      key={index}
                      style={{
                        padding: "8px 0px 8px 0px ",
                        borderBottom: "1px solid lightgray",
                      }}
                    >
                      <strong>Spec Section:</strong> {error["Spec Section"]}
                      <br />
                      <strong>Submittal Title:</strong>{" "}
                      {error["Submittal Title"]}
                      <br />
                      <strong>Submittal Number:</strong>{" "}
                      {error["Submittal Number"]}
                      <br />
                      <strong>Submittal Revision:</strong>
                      {error["Submittal Revision"]}
                      <br />
                      <strong>Column Name:</strong> {error["Column Name"]}
                      <br />
                      <strong>Column Value:</strong> {error["Column Value"]}
                      <br />
                      <strong>Error:</strong> {error["Error"]}
                      <br />
                    </div>
                  ))}
                </div>
              }
              type="error"
            />
          )}
        </div>
      </Modal>
    </div>
  );
}

export default PostSubmittals;
